/**
 * Formats a vessel/ship name into a consistent Title Case form so names are
 * displayed the same way everywhere (e.g. `"MAERSK ALABAMA"` -> `"Maersk Alabama"`).
 *
 * Use this for any user-facing vessel name. Do NOT use it for values that must
 * stay raw (DOM ids, search/sort keys, API or cross-window payloads).
 */
export function formatVesselName(name: string | null | undefined): string {
  if (!name) return '';

  return name
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
